import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Link } from '@mui/material';
import { RiskGroupDto, RiskGroupDriverDto } from '../../models/medicalCheckups/riskGroupDto';
import { DateUtils } from '../../helpers/dateUtils';
import { ROUTES } from '../../constants/routes';

interface RiskGroupDataTableProps {
    data: RiskGroupDto | null;
}

export const RiskGroupDataTable: React.FC<RiskGroupDataTableProps> = ({ data }) => {
    return (
        <Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ textAlign: 'center' }}>
                            <TableCell rowSpan={2}>№ п/п</TableCell>
                            <TableCell rowSpan={2}>ФИО водителей, отстраненных от работы</TableCell>
                            <TableCell colSpan={6} sx={{ py: 0 }}>Причина недопуска к управлению автомобиля</TableCell>
                            <TableCell rowSpan={2}>Количество недопусков/пройденных медосмотров</TableCell>
                            <TableCell rowSpan={2}>Недопуски (%) от пройденных мед.осмотров</TableCell>
                        </TableRow>
                        <TableRow sx={{ textAlign: 'center' }}>
                            <TableCell sx={{ width: '14%', py: 0 }}>Номер осмотра</TableCell>
                            <TableCell sx={{ width: '14%', py: 0 }}>Дата проведения мед.осм.</TableCell>
                            <TableCell sx={{ width: '14%', py: 0 }}>АД (мм.рт.ст.)</TableCell>
                            <TableCell sx={{ width: '14%', py: 0 }}>Пульс (уд/мин)</TableCell>
                            <TableCell sx={{ width: '14%', py: 0 }}>Температура</TableCell>
                            <TableCell sx={{ width: '14%', py: 0 }}>Содерж.алког.в выд.воздухе (мг/л)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.drivers.length > 0 ? (
                            data.drivers.map((driver: RiskGroupDriverDto, idx: number) => (
                                driver.measurements.length > 0 ? (
                                    driver.measurements.map((m: any, i: number) => (
                                        <TableRow key={`${driver.id}-${i}`} sx={{ textAlign: 'center' }}>
                                            {i === 0 && <TableCell rowSpan={driver.measurements.length}>{idx + 1}</TableCell>}
                                            {i === 0 && <TableCell rowSpan={driver.measurements.length}>{driver.fullName}</TableCell>}
                                            <TableCell sx={{ width: '14%', py: 0 }}>
                                                {m.checkupId ? (
                                                    <Link href={ROUTES.medicalCheckups.idPath.replace(':id', String(m.checkupId))} target="_blank" rel="noopener noreferrer">
                                                        {m.checkupId}
                                                    </Link>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ width: '14%', py: 0 }}>
                                                {DateUtils.formatDate(m.date)}
                                            </TableCell>
                                            <TableCell sx={{ width: '14%', py: 0 }}>
                                                {m.upperPressure && m.lowerPressure ? `${m.upperPressure}/${m.lowerPressure}` : '-'}
                                            </TableCell>
                                            <TableCell sx={{ width: '14%', py: 0 }}>{m.pulse || '-'}</TableCell>
                                            <TableCell sx={{ width: '14%', py: 0 }}>{m.temperature || '-'}</TableCell>
                                            <TableCell sx={{ width: '14%', py: 0 }}>{m.alcohol ? m.alcohol.toFixed(2) : '-'}</TableCell>
                                            {i === 0 && <TableCell rowSpan={driver.measurements.length}>{driver.rejectedCheckupsCount}/{driver.totalCheckups}</TableCell>}
                                            {i === 0 && <TableCell rowSpan={driver.measurements.length}>{driver.rejectedCheckupsPercent.toFixed(2)}%</TableCell>}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow key={driver.id} sx={{ textAlign: 'center' }}>
                                        <TableCell>{idx + 1}</TableCell>
                                        <TableCell>{driver.fullName}</TableCell>
                                        <TableCell>-</TableCell>
                                        <TableCell colSpan={5}>Нет данных измерений</TableCell>
                                        <TableCell>{driver.rejectedCheckupsCount}/{driver.totalCheckups}</TableCell>
                                        <TableCell>{driver.rejectedCheckupsPercent.toFixed(2)}%</TableCell>
                                    </TableRow>
                                )
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8} align="center">
                                    <Typography sx={{ color: '#999999', mt: 3, mb: 3, textAlign: 'center' }} component={'span'}>
                                        Нет данных для отображения. Пожалуйста, заполните фильтры и нажмите "Новый отчет".
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}; 